/** @module csi/property/ImageDropController */
define([
	"dojo/_base/declare",
	"csi/action/_ImageUploadMixin",
	"csi/action/Controller"
], function(declare, _ImageUploadMixin, Controller) {

	/**
	 * This controller works in conjunction with _DndHTML5Mixin
	 * First add that mixin (_DndHTML5Mixin) to your widget declaration, then initialize it, and define onDrop function.
	 * Then _DndHTML5Mixin will accept dropped images and return list of dropped files to the widget
	 * Those files will be downloaded to the client and mixin returns {File[]) to the widget 
	 * 
	 * Then widget invoking new Action(), using this controller, controller uploads images to the server - _ImageUploadMixin.preProcess();
	 * If successful it will call _ImageSaveMixin.onSave() to add images to the widget's root node.
	 * PostProcess will show those newly added images, selecting the first one.
	 */

	return declare([Controller, _ImageUploadMixin], {
		/**
		 * @override
		 * Add selected image(s) to node
		 */
		toWriter() {
			const {heading, type} = this.widget.imageSpec;
			this._toWriterImages(heading.m_id, type);
		},

		/**
		 * @override
		 * If new image(s) selected, then refresh and show first one
		 */
		postProcessSuccess() {
			this.widget.refreshImages(this._firstKey);
		}
	});
});